import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useStores } from '../hooks/use-stores';
import { querystring } from '../utils/helpers';
import ErrorMessage from '../components/errormessage';
import {
    FlexDiv,
    Block,
    Heading1,
    TextInput,
    TextDefault,
    TextTiny,
    ThemedButton,
} from '@awarego-ui/components';

function SignIn({ company_id, campaign_id, subject_id }) {
    const { authStore, brandingStore, companyStore } = useStores();
    const { loginError, emailLoginError } = authStore;
    const { account_name, termsUrl } = brandingStore;
    const { t } = useTranslation();
    const location = useLocation();
    const emailResent = querystring('emailResent', location.pathname + location.search) === '1';

    let navigate = useNavigate();

    const [email, setEmail] = useState('');

    const handleEmailChange = (event) => {
        setEmail(event.target.value.trim());
    };

    const handleBlur = () => {
        localStorage.setItem('savedEmail', email);
    };

    // Load previously entered email from local storage
    useEffect(() => {
        const savedEmail = localStorage.getItem('savedEmail');
        if (savedEmail) {
            setEmail(savedEmail);
        }
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        authStore.setEmail(email);
        const companyId = company_id || companyStore.companyId || parseInt(window.localStorage.getItem('companyId'))
        const result = await authStore.signin(
            email,
            companyId,
            campaign_id,
            subject_id
        );
        if (result === 'redirect') return;
        if (result) navigate('/auth/check-email');
    };
    return (
        <FlexDiv justifyCenter alignCenter wrapper column>
            {(loginError && loginError.length > 0 && (
                <ErrorMessage error={loginError} />
            )) ||
                (emailLoginError && (
                    <ErrorMessage error={emailLoginError} />
                )) ||
                (emailResent && (
                    <ErrorMessage
                        error={t('emailWasResent')}
                        errorType="warning"
                    />
                ))}
            <Block width={570}>
                <Heading1>{t('Sign in')}</Heading1>
                <TextDefault lighter mb={24}>
                    {t('enterWorkEmail')}
                </TextDefault>
                <form
                    id="signin"
                    method="post"
                    action="/auth/email/signin"
                    onSubmit={handleSubmit}
                >
                    <FlexDiv column gap={16}>
                        <TextInput
                            placeholder={t('genericWorkAddress')}
                            stretched
                            aria-describedby="emailHelp"
                            value={email}
                            onChange={handleEmailChange}
                            name="email"
                            onBlur={handleBlur}
                            autoComplete="email"
                            type="email"
                            label={t('workEmailLabel')}
                            overwriteGlobalStyles
                            error={
                                (loginError && loginError.length > 0) ||
                                !!emailLoginError
                            }
                            helperText={
                                loginError && loginError.length > 0
                                    ? loginError
                                    : undefined
                            }
                        />
                        {
                            <ThemedButton
                                mode="primary"
                                size="fullWidth"
                                type="submit"
                                text={t('Continue')}
                            />
                        }
                    </FlexDiv>
                </form>
                <TextTiny lighter mt={16}>
                    {t(`signInAgreement`, { account_name })}{' '}
                    <a
                        href={termsUrl}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <u>{t('Terms of service')}</u>
                    </a>
                </TextTiny>
            </Block>
        </FlexDiv>
    );
}

export default observer(SignIn);
